// ======================================================================
// File Name       : MessageThreadDetailUserList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button, Col, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { parseDateForDetail } from '../../utils/index';
import PaginationCustom from '../Pagination';
import TableHead from '../TableHead';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';

const thead = [
  { title: 'ログインID', sortBy: null },
  { title: 'ユーザー名', sortBy: null },
  { title: '所属グループ名', sortBy: null },
  { title: '送信日時', sortBy: null, width: 165 },
  { title: '操作', sortBy: null, width: 110 },
];

class MessageThreadDetailUserList extends React.Component {
  render() {
    const {
      messageThreadDetailUserList,
      userListRecordNum,
      startPosition,
      sent,
      rootMessageIdAuto,
      getStartEndData,
    } = this.props;
    let path = Path.RECEIVE_CHAT_DETAIL;
    if (sent) {
      path = Path.SENT_CHAT_DETAIL;
    }
    path = path.replace(':messageRootId', rootMessageIdAuto);
    let tbody = null;
    if (messageThreadDetailUserList && messageThreadDetailUserList.length) {
      tbody = messageThreadDetailUserList.map((userInfo, index) => {
        if (!userInfo) {
          return null;
        }
        const to = path.replace(':userSecernId', userInfo.userSecernId);
        return (
          <tr key={index}>
            <td className="text-left">{userInfo.loginId}</td>
            <td className="text-left">{userInfo.userName}</td>
            <td className="text-left">{userInfo.groupNames}</td>
            <td className="text-left">{parseDateForDetail(userInfo.createdAt)}</td>
            <td className="text-center">
            <CustomLink
                className="margin-right-7 link-detail"
                to={to}
                text="送信"
              />
            </td>
          </tr>
        );
      });
    }
    return (
      <div>
        <Col sm={12} className="padding-left-right-clear margin-top-10 margin-bottom-10">
          <Col sm={3} style={{ marginTop: '20px' }} className="padding-left-clear">
            <p> 送信先ユーザー一覧</p>
          </Col>
        </Col>
        <Table striped hover>
          <thead>
            <TableHead data={thead} />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
        <Col sm={12} className="d-flex justify-content-center">
          <PaginationCustom
            recordNum={userListRecordNum}
            handlePageSelect={getStartEndData}
            startPosition={startPosition}
          />
        </Col>
      </div>
    );
  }
}

export default MessageThreadDetailUserList;
